import { render, staticRenderFns } from "./CampaignTableRowItem.vue?vue&type=template&id=5b9b4a03&scoped=true&"
import script from "./CampaignTableRowItem.vue?vue&type=script&lang=ts&"
export * from "./CampaignTableRowItem.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignTableRowItem.vue?vue&type=style&index=0&id=5b9b4a03&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9b4a03",
  null
  
)

export default component.exports